// extracted by mini-css-extract-plugin
export var infoItem = "_ns-2";
export var title = "_ns-0";
export var value = "_ns-1";